import cn from 'clsx';
import { Sku } from '@v2/shared/lib/types';
import Currency from '@v2/shared/components/Currency';
import { useSite } from '@v2/shared/lib/site';
import useProductPriceLogic from '@v2/shared/lib/useProductPriceLogic';

type SavingsProps = {
  sku: Sku;
  showAmount?: boolean;
  className?: string;
};

export default function Savings({ sku, showAmount, className }: SavingsProps) {
  const site = useSite();
  const { showSavings } = useProductPriceLogic(sku);
  if (!showSavings) return null;

  const price = sku.sale_price || sku.price;
  const percentage = (100 - (price / sku.msrp) * 100).toFixed(0);
  const savingsAmount = sku.msrp - price;

  return (
    <span className={cn('text-emerald-700 font-semibold', className)}>
      {showAmount && (
        <>
          You save <Currency value={savingsAmount} currencyCode={site.currency} /> ({percentage}%)
        </>
      )}
      {!showAmount && <>Save {percentage}%</>}
    </span>
  );
}
